import { AlertCircle, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ProjectLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentTier: string;
  maxProjects: number;
}

export function ProjectLimitModal({ isOpen, onClose, currentTier, maxProjects }: ProjectLimitModalProps) {
  const navigate = useNavigate();
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4">
        <div className="text-center mb-6">
          <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="h-8 w-8 text-yellow-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Project Limit Reached
          </h3>
          <p className="text-gray-600">
            Your {currentTier} plan is limited to {maxProjects} {maxProjects === 1 ? 'project' : 'projects'}. Upgrade your subscription to create more projects.
          </p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 mb-6">
          <div className="flex">
            <Building2 className="h-5 w-5 text-blue-500 flex-shrink-0" />
            <div className="ml-3">
              <h4 className="text-sm font-medium text-blue-800">
                Business Plan Benefits
              </h4>
              <ul className="mt-2 text-sm text-blue-700 list-disc list-inside">
                <li>Up to 5 solar projects</li>
                <li>50kW system size limit</li>
                <li>Advanced reporting</li>
                <li>Priority support</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex space-x-4">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
          >
            Maybe Later
          </button>
          <button
            onClick={() => navigate('/subscription')}
            className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            Upgrade Now
          </button>
        </div>
      </div>
    </div>
  );
}